import { render } from "./AcceptedWIPView.vue?vue&type=template&id=6cd8db06&scoped=true"
const script = {}

import "./AcceptedWIPView.vue?vue&type=style&index=0&id=6cd8db06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd8db06"]])

export default __exports__